// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__tPlNX","withPadding":"Breadcrumbs_withPadding__5NLVV","link":"Breadcrumbs_link__SJTyF","text":"Breadcrumbs_text__b2FW9"};